import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserComponent } from './user.component';
import { DragDropModule } from '../../drag-drop/drag-drop.module';
import { CommonModule } from '@angular/common';

export const USER_COMPONENTS = [UserComponent];

@NgModule({
  declarations: USER_COMPONENTS,
  imports: [TranslateModule, CommonModule, DragDropModule],
  exports: USER_COMPONENTS,
})
export class UserModule {}
